import styled from 'styled-components';

type ImageEmojiWrapperProps = {
  verticalAlign?:
    | 'top'
    | 'middle'
    | 'bottom'
    | 'baseline'
    | 'sub'
    | 'super'
    | 'text-top'
    | 'text-bottom';
};

export const ImageEmojiWrapper = styled.span<ImageEmojiWrapperProps>`
  img {
    vertical-align: ${({ verticalAlign = 'top' }) => verticalAlign};
  }
`;
